
export * from './font-data';
export * from './font';

export * from './properties';

export * from './text-char';
export * from './text-layout';

export * from './auto-create-multi-part';
export * from './multi-part';

export * from './text';
export * from './monogram';



/** WEBPACK FOOTER **
 ** ./src/cdl/figure/text/index.js
 **/